import { MapContainer, Marker, Popup, TileLayer, useMap, useMapEvent, useMapEvents, WMSTileLayer, ZoomControl } from "react-leaflet";
import { HeatmapLayer } from 'react-leaflet-heatmap-layer-v3';
import { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import L, { CRS } from 'leaflet';

import Player from "./player";
import Window from "./window";
import Files from "./files";

const Map = () => {

    const [files, setFiles] = useState({"images": [], "folders": [
      {
        "id": 5,
        "title": "Featured",
        "icon": "/images/bgs/star.png"
      },
      {
        "id": 6,
        "title": "Pictures",
        "icon": "/images/bgs/image-folder.png"
      },
      {
          "id": 7,
          "title": "Videos",
          "icon": "/images/bgs/video-folder.png"
      }]}
    );

    const params = useSearchParams()

    useEffect(() => {
      axios.get('https://nexsu.arina.lol/api/win7/files').then((res) => {
        setFiles(res.data)
      })
    }, [])

    const MapWrapper = () => {

        const resetSlideWindows = () => {
            var sheet = document.styleSheets[2];
            var rules = sheet.cssRules || sheet.rules;
            rules[0].style.transform = `translateX(0%)`;
        }

        const SpecialPolys = () => {

            const markerRef = useRef([])

            const [markerstore, setMarkerstore] = useState([])
            const [markerstate, setMarkerstate] = useState([])
            const [heatmapstate, setHeatmapstate] = useState([])

            const zoomed = useMapEvents({
                zoom: () => {
                    const regex = new RegExp(`marker-[0-9]+(?!\S)`, 'g');
                    document.querySelectorAll(".leaflet-marker-icon").forEach((el) => el.className = el.className.replaceAll(regex, `marker-${map.getZoom().toFixed(0)}`))
                },
                popupclose: () => {
                    resetSlideWindows()
                }
            })

            useEffect(() => {
                syncMarkers()
            }, [])

            const syncMarkers = (arch) => {
                if (arch) {
                    axios.get('https://nexsu.arina.lol/api/win7/files').then((res) => {
                        setFiles(res.data)
                    })
                }
                axios.get('https://nexsu.arina.lol/api/win7/markers').then((res) => {
                    var mark = []
                    var heat = []
                    res.data.forEach((el) => {
                        if (el.win7id !== null) {
                            mark.push({"coordinates": el.coordinates?.reverse(), "type": el.type, "link": el.link, "win7id": el.win7id, "date": el.date, "filter": el.filters});
                            heat.push([el.coordinates[0], el.coordinates[1], 30]);
                        }
                    })
                    setMarkerstate(mark)
                    setMarkerstore(mark)
                    setHeatmapstate(heat)
                    markerRef.current = markerRef.current.slice(0, mark.length)
                })
            }

            const archiveMarkers = () => {
                axios.get('https://nexsu.arina.lol/api/win7/archivedmarkers').then((res) => {
                    var mark = []
                    var heat = []
                    res.data.forEach((el) => {
                        if (el.win7id !== null) {
                            mark.push({"coordinates": el.coordinates?.reverse(), "type": el.type, "link": el.link, "win7id": el.win7id, "date": el.date, "filter": el.filters});
                            heat.push([el.coordinates[0], el.coordinates[1], 30]);
                        }
                    })
                    setMarkerstate(mark)
                    setMarkerstore(mark)
                    setHeatmapstate(heat)
                    markerRef.current = markerRef.current.slice(0, mark.length)
                })
            }

            const setFilter = () => {
                var fl = sessionStorage.getItem('markerfilter')
                if (fl !== '' && fl !== null) {
                    var newarr = []
                    var newheat = []
                    markerstore.forEach((el) => {
                        if(el.type.includes(fl)) {
                            newarr.push(el)
                            newheat.push([el.coordinates[0], el.coordinates[1], 30])
                        }
                    })
                    setMarkerstate(newarr)
                    setHeatmapstate(newheat)
                } else {
                    setMarkerstate(markerstore)
                    var newheat = []
                    markerstore.forEach((el) => {
                        newheat.push([el.coordinates[0], el.coordinates[1], 30])
                    })
                    setHeatmapstate(newheat)
                }
            }

            const textFilter = () => {
                var fl = sessionStorage.getItem('textfilter')
                if (fl !== '' && fl !== null) {
                    var newarr = []
                    var newheat = []
                    markerstore.forEach((el) => {
                        var c = 0
                        fl.split(' ').forEach((li) => {
                            if(!el.filter?.includes(li)) {
                                c++;
                            }
                        })
                        if (c === 0) {                            
                            newarr.push(el)
                            newheat.push([el.coordinates[0], el.coordinates[1], 30])
                        }
                    })
                    setMarkerstate(newarr)
                    setHeatmapstate(newheat)
                } else {
                    setMarkerstate(markerstore)
                    var newheat = []
                    markerstore.forEach((el) => {
                        newheat.push([el.coordinates[0], el.coordinates[1], 30])
                    })
                    setHeatmapstate(newheat)
                }
            }

            const map = useMap()

            const panMap = (force, iter, max) => {
                if (localStorage.getItem('activeImage') !== null) {
                    const id = localStorage.getItem('activeImage')
                    markerstate.forEach((el) => {
                        if(el.win7id.includes(id)) {
                            var latlng = [el.coordinates[0] + 0.1, el.coordinates[1]]
                            map.flyTo(latlng, 8)
                            markerRef.current.forEach((li, ind) => {
                                if(li?._latlng.lat === el.coordinates[0]) return console.log(markerRef.current[ind]._icon.click())
                            })
                        }
                    })
                }
                if (markerstate.length < 1 && force && iter < max) {
                    setTimeout(() => {
                        panMap(true, iter + 1, 10)
                    }, [2000])
                }
            }

            useEffect(() => {
                // get uri path. if theres a simple redirect then open the associated marker
                var win7id = params[0]?.getAll('marker')[0];
                localStorage.setItem('activeImage', win7id);
                sessionStorage.setItem('redirect', 'T')
            }, [params])

            useEffect(() => {
                if(sessionStorage.getItem('redirect') === 'T' && markerstate.length > 0) {
                    sessionStorage.setItem('redirect', 'F')
                    setTimeout(() => {
                        panMap(true, 0, 10)
                    }, [500])
                }
            }, [markerstate, setMarkerstate])

            const eventHandlers = useMemo(() => ({
                popupopen(e) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?marker=${e.sourceTarget.options.win7id}`;
                    window.history.replaceState(null, '', newurl)
                    var ts = e.sourceTarget.options.timestamp;
                    document.querySelector('.leaflet-marker-currently-focused')?.classList.remove('leaflet-marker-currently-focused')
                    e.sourceTarget._icon.classList.add('leaflet-marker-currently-focused')
                    if (ts !== undefined) {
                        sessionStorage.setItem('timestamp', ts)
                        document.getElementById('setarchivedate').focus()
                    }
                }
            }))

            const slideWindows = (direction) => {
                console.log(document.styleSheets)
                var sheet = document.styleSheets[2];
                console.log(sheet)
                var rules = sheet.cssRules || sheet.rules;
                const reg = /\(([^)]*)\)/g;
                var curval = rules[0].style.transform.match(reg)[0]
                var p1 = curval.replaceAll(/\(/g, "")
                p1 = p1.replaceAll(/\)/g, "")
                rules[0].style.transform = `translateX(${parseInt(p1.substring(0, p1.length - 1)) + (100 * direction)}%)`;
            }

            return (
                <>
                    <button id="panmap" style={{opacity: 0}} onClick={() => panMap(false, 0, 0)} ></button>
                    <button id="setfilter" style={{opacity: 0}} onClick={() => setFilter()} ></button>
                    <button id="settextfilter" style={{opacity: 0}} onClick={() => textFilter()} ></button>
                    {heatmapstate.length > 1 ?
                    <HeatmapLayer
                        points={heatmapstate}
                        longitudeExtractor={m => m[1]}
                        latitudeExtractor={m => m[0]}
                        intensityExtractor={m => parseFloat(m[2])}
                        max={200}
                        blur={10}
                        minOpacity={0.05}
                        radius={40}
                        gradient={{0.4: 'blue', 0.8: 'cyan', 1.0: 'aliceblue'}}
                    />
                    :null}
                    <button id="archivemode" style={{display: 'none'}} onClick={() => archiveMarkers()} ></button>
                    <button id="regularmode" style={{display: 'none'}} onClick={() => syncMarkers(true)} ></button>
                    {markerstate?.map((el, ind) => {
                        var size = 16
                        var split = el.link.split(',')
                        if (el.type.includes('v-') || el.type.includes('t-')) size = 24;
                        if (el.type.includes('mu-')) {
                            size = 32;
                            return (
                                <Marker eventHandlers={eventHandlers} win7id={el.win7id} timestamp={el.date} ref={(e) => (markerRef.current[ind] = e)} key={`mark-${el.coordinates[0]}-${ind}`} icon={L.icon({iconUrl: `/images/markers/${el.type}-marker.png`, className: 'marker-0', iconSize: [size, size], iconAnchor: [size / 2, size / 2], popupAnchor: [0, 0]})} position={el.coordinates} >
                                    <Popup>
                                        <div className="media-player aero-border" style={{height: '100%'}}>
                                            <div className="multimedia-container" style={{overflow: 'scroll', display: 'grid', gridTemplateRows: '100%', gridTemplateColumns: 'repeat(10, 100%)', padding: '4px', height: 'calc(100% - 8px)'}}>
                                                {split.map((li, ind) => {
                                                    var win7id = split[ind]
                                                    return (
                                                        <div className="sliding-window" style={{display: 'grid', gridTemplateColumns: '25px calc(100% - 50px) 25px', padding: "0 3px", gridTemplateRows: '100%', alignItems: 'center'}}>
                                                            {ind !== 0 ? <div style={{zIndex: 3}}><button className="window-slide-button" onClick={() => slideWindows(1)}><img alt="decor" width={'16px'} height={'16px'} src="/images/bgs/nav-arrow.png" /></button></div> : <p></p>}
                                                            <Window exittype={1} window={<Player imgdata={{type: "image", short: "", source: li.substring(1), win7id: win7id}} newtab={false} thumb={true}/>} title={"Windows Media Player"} iconpath={"/images/bgs/mediaplayer.png"} closemap={true} />
                                                            {ind !== (split.length - 1) ? <div style={{zIndex: 3}}><button className="window-slide-button" onClick={() => slideWindows(-1)}><img alt="decor" style={{transform: 'rotateY(180deg)'}} width={'16px'} height={'16px'} src="/images/bgs/nav-arrow.png" /></button></div> : <p></p>}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </Popup>
                                </Marker>
                            )
                        } else {
                            return (
                                <Marker eventHandlers={eventHandlers} win7id={el.win7id} timestamp={el.date} ref={(e) => (markerRef.current[ind] = e)} key={`mark-${el.coordinates[0]}-${ind}`} icon={L.icon({iconUrl: `/images/markers/${el.type}-marker.png`, className: 'marker-0', iconSize: [size, size], iconAnchor: [8, 0], popupAnchor: [0, 0]})} position={el.coordinates} >
                                    <Popup>
                                        <div className="media-player aero-border" style={{height: '100%'}}>
                                            <Window exittype={1} window={<Player imgdata={{type: "image", short: "", source: el.link.substring(1), win7id: el.win7id}} newtab={false} thumb={true}/>} title={"Windows Media Player"} iconpath={"/images/bgs/mediaplayer.png"} closemap={true} />
                                        </div>
                                    </Popup>
                                </Marker>
                            )
                        }
                    })}
                </>
            )
        }

        const ArchivedImagery = () => {

            const [datetime, setDatetime] = useState({date: "2023-03-31", time: "20:00:00"})
            const [display, setDisplay] = useState(false)

            const setArchiveDate = () => {
                var ts = sessionStorage.getItem('timestamp')
                if (ts !== undefined) {
                    setDisplay(false)
                    setTimeout(() => {
                        document.getElementById('radar-control').classList.remove('radar-closed')
                        document.getElementById('resetradarcontrol').click()
                        var txt = ts.split("T")
                        var tmp = {date: `${txt[0]}`, time: `${txt[1].substring(0, txt[1].length - 5)}`}
                        sessionStorage.setItem('date', `${txt[0]}`)
                        sessionStorage.setItem('time', `${txt[1].substring(0, txt[1].length - 5)}`)
                        setDatetime(tmp)
                        setDisplay(true)
                    }, [1000])
                }
            }

            const updateArchiveDate = () => {
                var ts = sessionStorage.getItem('timestamp')
                if (ts !== undefined) {
                    setDisplay(false)
                    setTimeout(() => {
                        var txt = ts.split("T")
                        var tmp = {date: `${txt[0]}`, time: `${txt[1]}`}
                        setDatetime(tmp)
                        setDisplay(true)
                    }, [1000])
                }
            }

            return (
                <>
                    <button id="setarchivedate" onFocus={() => setArchiveDate()} ></button>
                    <button id="updatearchivedate" onFocus={() => updateArchiveDate()}></button>
                    {display ?
                        <WMSTileLayer
                            attribution="<a href='https://www.ncei.noaa.gov/maps/radar/'>NOAA NCEI</a>"
                            url="https://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r-t.cgi"
                            layers="nexrad-n0r-wmst"
                            transparent="true"
                            format="image/png"
                            bgcolor="0x000000"
                            version="1.1.1"
                            styles="default"
                            crs={CRS.EPSG3857}
                            time={`${datetime.date}T${datetime.time}Z`}
                            opacity={0.75}
                            className="leaflet-radar-tilelayer"
                        />
                    : null}
                </>
            )
        }

        return (
            <>
                <MapContainer style={{height: '100%', zIndex: 2}} center={[41, -88]} zoom={4} scrollWheelZoom={true}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <ZoomControl position="bottomright" />
                    <ArchivedImagery/>
                    <SpecialPolys/>
                </MapContainer>
            </>
        )
    }

    const updateFilter = (value) => {
        sessionStorage.setItem('markerfilter', value)
        document.getElementById('setfilter').click()
    }

    const updateTextFilter = (value) => {
        sessionStorage.setItem('textfilter', value)
        document.getElementById('settextfilter').click()
    }

    const changeOpacity = (layer, value) => {
        if (layer === 'heatmap') {
            document.querySelector('.leaflet-overlay-pane').style.opacity = (value / 100)
        } else if (layer === 'radar') {
            document.querySelector('.leaflet-radar-tilelayer').style.opacity = (value / 100)
        } else {
            document.querySelector('.leaflet-marker-pane').style.opacity = (value / 100)
        }
    }

    const RadarControl = () => {
        const [sliderval, setSliderval] = useState(0)
        const [visidate, setVisidate] = useState("")

        const updateArchiveDate = (e) => {
            var monthval = [31, 27, 31, 30, 31, 30, 31, 30, 31, 30, 31, 30]
            var time = sessionStorage.getItem('time')
            var date = sessionStorage.getItem('date')
            setSliderval(e.currentTarget.value)
            function mod(n, m) { // needed for js modulo bug with negatives. some would even call it a feature, woaw
                return ((n % m) + m) % m;
            }
            if (time !== undefined) {
                var stepvalmin = (e.currentTarget.value * 5) % 60;
                var stepvalhor = Math.floor(((e.currentTarget.value * 5) + (parseInt(time.split(":")[1]))) / 60)
                var min = mod(stepvalmin + parseInt(time.split(":")[1]), 60)
                var hour = mod(parseInt(time.split(":")[0]) + stepvalhor, 24)
                var stepvalday = ((stepvalhor + (parseInt(time.split(":")[0]))) / 24)
                if (stepvalday >= 1) {
                    var month = parseInt(date.split("-")[1])
                    var day = parseInt(date.split("-")[2])
                    var newday = (day + 1) % monthval[month]
                    var newmonth = month
                    if ((day + 1) / monthval[month] > 1) {
                        newmonth = month + 1
                    } // listen, i know. i know its bad, okay. please, have mercy upon me for if-fing what could easily be solved in a differential
                    // for whatever reason my brain struggles when working in translating dates
                    // also yeah, i could probably do this better with a library to subtract from a date object, but im trying to use as little libraries as possible
                    // and also the chance that im going to post something that will radar-translate over the new year is so low that im not going to entertain it
                    date = `${date.split("-")[0]}-${newmonth < 10 ? "0" : ""}${newmonth}-${newday < 10 ? "0" : ""}${newday}`
                } else if (stepvalday <= -1) {
                    var month = parseInt(date.split("-")[1])
                    var day = parseInt(date.split("-")[2])
                    var newday = mod(day - 1, monthval[month])
                    var newmonth = month
                    if ((day - 1) < 1) {
                        newmonth = month + -1
                    }
                    date = `${date.split("-")[0]}-${newmonth < 10 ? "0" : ""}${newmonth}-${newday < 10 ? "0" : ""}${newday}`
                }
                time = `${hour < 10 ? "0" : ""}${hour}:${min < 10 ? "0" : ""}${min}:00`;
                sessionStorage.setItem('timestamp', `${date}T${time}`)
                document.getElementById('updatearchivedate').focus()
                var qdate = new Date(`${date}T${time}`).toString().split(":")
                setVisidate(`- ${qdate[0]}:${qdate[1]}z`)
            }
        }

        const manualUpdate = (val) => {
            var monthval = [31, 27, 31, 30, 31, 30, 31, 30, 31, 30, 31, 30]
            var time = sessionStorage.getItem('time')
            var date = sessionStorage.getItem('date')
            function mod(n, m) { // needed for js modulo bug with negatives. some would even call it a feature, woaw
                return ((n % m) + m) % m;
            }
            if (time !== undefined) {
                var stepvalmin = (val * 5) % 60;
                var stepvalhor = Math.floor(((val * 5) + (parseInt(time.split(":")[1]))) / 60)
                var min = mod(stepvalmin + parseInt(time.split(":")[1]), 60)
                var hour = mod(parseInt(time.split(":")[0]) + stepvalhor, 24)
                var stepvalday = ((stepvalhor + (parseInt(time.split(":")[0]))) / 24)
                if (stepvalday >= 1) {
                    var month = parseInt(date.split("-")[1])
                    var day = parseInt(date.split("-")[2])
                    var newday = (day + 1) % monthval[month]
                    var newmonth = month
                    if ((day + 1) / monthval[month] > 1) {
                        newmonth = month + 1
                    } // listen, i know. i know its bad, okay. please, have mercy upon me for if-fing what could easily be solved in a differential
                    // for whatever reason my brain struggles when working in translating dates
                    // also yeah, i could probably do this better with a library to subtract from a date object, but im trying to use as little libraries as possible
                    // and also the chance that im going to post something that will radar-translate over the new year is so low that im not going to entertain it
                    date = `${date.split("-")[0]}-${newmonth < 10 ? "0" : ""}${newmonth}-${newday < 10 ? "0" : ""}${newday}`
                } else if (stepvalday <= -1) {
                    var month = parseInt(date.split("-")[1])
                    var day = parseInt(date.split("-")[2])
                    var newday = mod(day - 1, monthval[month])
                    var newmonth = month
                    if ((day - 1) < 1) {
                        newmonth = month + -1
                    }
                    date = `${date.split("-")[0]}-${newmonth < 10 ? "0" : ""}${newmonth}-${newday < 10 ? "0" : ""}${newday}`
                }
                time = `${hour < 10 ? "0" : ""}${hour}:${min < 10 ? "0" : ""}${min}:00`;
                sessionStorage.setItem('timestamp', `${date}T${time}`)
                document.getElementById('updatearchivedate').focus()
                var qdate = new Date(`${date}T${time}`).toString().split(":")
                setVisidate(`- ${qdate[0]}:${qdate[1]}z`)
            }
        }

        const setSlidervalM = (val) => {
            setSliderval(val)
            manualUpdate(val)
        }

        return (
            <div id="radar-control" className="radar-control radar-closed aero-border mobilehide" style={{zIndex: 400, position: 'absolute', display: 'grid', gridTemplateColumns: 'calc(100% - 25px) 25px', gridTemplateRows: '100%', alignItems: 'center', bottom: 0, marginLeft: '15vw', maxHeight: '20vh'}}>
                <button id="resetradarcontrol" style={{display: 'none'}} onClick={() => setSliderval(0)}></button>
                <fieldset>
                    <legend>Radar Timeline {visidate}</legend>
                    <input id="radar-controller" style={{width: '100%', padding: '3px', borderRadius: '8px', background: 'rgba(0,0,0,0.1)'}} type="range" max={24} min={-24} step={1} defaultValue={0} value={sliderval} onChange={(e) => updateArchiveDate(e)} />
                    <datalist id="radar-controller">
                        <option onClick={() => setSlidervalM(-24)}>-120</option><option onClick={() => setSlidervalM(-22)}>-110</option><option onClick={() => setSlidervalM(-20)}>-100</option>
                        <option onClick={() => setSlidervalM(-18)}>-90</option> <option onClick={() => setSlidervalM(-16)}>-80</option> <option onClick={() => setSlidervalM(-14)}>-70</option>
                        <option onClick={() => setSlidervalM(-12)}>-60</option> <option onClick={() => setSlidervalM(-10)}>-50</option> <option onClick={() => setSlidervalM(-8)}>-40</option>
                        <option onClick={() => setSlidervalM(-6)}>-30</option>  <option onClick={() => setSlidervalM(-4)}>-20</option> <option onClick={() => setSlidervalM(-2)}>-10</option> 
                        <option onClick={() => setSlidervalM(0)} className="centeroid"> 0</option>
                        <option onClick={() => setSlidervalM(2)}>+10</option>  <option onClick={() => setSlidervalM(4)}>+20</option> <option onClick={() => setSlidervalM(6)}>+30</option>
                        <option onClick={() => setSlidervalM(8)}>+40</option>  <option onClick={() => setSlidervalM(10)}>+50</option> <option onClick={() => setSlidervalM(12)}>+60</option>
                        <option onClick={() => setSlidervalM(14)}>+70</option> <option onClick={() => setSlidervalM(16)}>+80</option> <option onClick={() => setSlidervalM(18)}>+90</option>
                        <option onClick={() => setSlidervalM(20)}>+100</option><option onClick={() => setSlidervalM(22)}>+110</option><option onClick={() => setSlidervalM(24)}>+120</option>
                    </datalist>
                </fieldset>
                <button title="Hides the radar controls." className="slider-button" style={{height: 'inherit', cursor: 'pointer', padding: 0, margin: 0, width: '100%', fontSize: '20px', borderLeft: 'none', borderRadius: '4px'}} onClick={() => document.getElementById('radar-control').classList.add('radar-closed')}>
                    <img width={'20px'} height={'20px'} src="/images/bgs/slide.png" alt="decor" />
                </button>
            </div>
        )
    }

    return (
        <>
            <div className="screen map-grid" style={{height: 'calc(100% - 16px)', background: 'white', overflow: 'hidden', position: 'relative'}}>
                <div className="nav-buttons browser-toolbar">
                    <p style={{color: 'gray'}}><u>F</u>ile</p>
                    <p style={{color: 'gray'}}><u>E</u>dit</p>
                    <p style={{color: 'gray'}}><u>V</u>iew</p>
                    <p style={{color: 'gray'}}><u>F</u>avorites</p>
                    <p style={{color: 'gray'}}><u>T</u>ools</p>
                    <p style={{color: 'gray'}}><u>H</u>elp</p>
                </div>
                <div style={{height: '3px', background: 'linear-gradient(0deg, #a7a398 0%, #bcd1ff 50%, #aabef4 100%)'}}></div>
                <div style={{background: '#bcd1ff', height: '100%'}}>
                    <MapWrapper/>
                </div>
                <div id="file-explorer" className="file-explorer aero-border left-panel">
                    <Window exittype={0} window={<Files files={files}/>} title={"File Explorer"} iconpath={"/images/bgs/file-folder.png"} />
                </div>
                <RadarControl/>
                <div id="filter-panel" className="filter-panel aero-border window-container">
                    <div style={{height: '100%', gridRow: 'span 2'}}>
                        <button title="Open/close the map controls." className="slider-button" style={{height: 'inherit', cursor: 'pointer', padding: 0, margin: 0, width: '100%', fontSize: '20px', borderLeft: 'none'}} onClick={() => document.getElementById('filter-panel').classList.toggle('filter-closed')}>
                            <img width={'20px'} height={'20px'} src="/images/bgs/slide.png" alt="decor" />
                        </button>
                    </div>
                    <div className="file-top-bar" style={{display: 'flex', justifyContent: 'center'}}>
                        <p style={{textAlign: 'center', borderRadius: '0 3px 0 0'}}>Map Controls</p>
                    </div>
                    <div className="controller-window-inner">
                        <div className="textbox" style={{width: 'calc(100% - 2px)', display: 'flex', margin: 0, marginTop: '4px'}}>
                            <input id="marker-search" onChange={(e) => updateTextFilter(e.currentTarget.value)} type="text" placeholder="State/Date/Event Name"></input>
                            <label htmlFor="marker-search">
                                <img src="/images/bgs/magnifier.png" alt="decor" width={'16px'} height={'16px'} />
                            </label>
                        </div>
                        <hr/>
                        <select className="folder-preview perm-active" style={{width: 'calc(100% - 8px)'}} onChange={(e) => updateFilter(e.currentTarget.value)} defaultValue={''}>
                            <option value={''}>          All</option>
                            <option value={'v-'}>        Video</option>
                            <option value={'t-'}>        Timelapse</option>
                            <option value={'supercell'}> Supercell</option>
                            <option value={'tornado'}>   Tornado</option>
                            <option value={'shelf'}>     Shelf</option>
                            <option value={'lightning'}> Lightning</option>
                            <option value={'clouds'}>    Clouds</option>
                            <option value={'aurora'}>    Aurora</option>
                            <option value={'landscape'}> Landscape</option>
                            <option value={'wildlife'}>  Wildlife</option>
                            <option value={'other'}>     Other</option>
                        </select>
                        <div style={{background: 'rgb(218, 218, 241)', height: 'fit-content'}}>
                            <div style={{background: 'white', borderRadius: '0 0 8px 8px', marginTop: '8px', height: '11px'}}></div>
                        </div>
                        <div style={{backgroundColor: 'rgb(218, 218, 241)'}}>
                            <fieldset className="fieldsets">
                                <legend>Heatmap Opacity</legend>
                                <input type="range" max={100} min={0} step={1} defaultValue={100} onChange={(e) => changeOpacity('heatmap', e.target.value)} />
                            </fieldset>
                            <fieldset className="fieldsets">
                                <legend>Marker Opacity</legend>
                                <input type="range" max={100} min={0} step={1} defaultValue={100} onChange={(e) => changeOpacity('marker', e.target.value)} />
                            </fieldset>
                            <fieldset className="fieldsets">
                                <legend>Radar Opacity</legend>
                                <input type="range" max={100} min={0} step={1} defaultValue={80} onChange={(e) => changeOpacity('radar', e.target.value)} />
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Map;